import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';

export const ActionSlot = ({ children }) => <Box sx={{ width: 36, flexShrink: 0 }}>{children}</Box>;

const ActionButton = ({ label, tooltip, Icon, color = 'primary', disabled, onClick }) => (
    <Tooltip title={tooltip ?? label} describeChild>
        <span>
            <IconButton
                size="small"
                aria-label={label}
                disabled={disabled}
                onClick={onClick}
                sx={{
                    borderRadius: 1,
                    bgcolor: `${color}.main`,
                    color: `${color}.contrastText`,
                    '&:hover': { bgcolor: `${color}.dark` },
                    '&.Mui-disabled': { bgcolor: 'action.disabledBackground', color: 'action.disabled' },
                }}
            >
                <Icon fontSize="small" />
            </IconButton>
        </span>
    </Tooltip>
);

export default ActionButton;
